<template>
    <v-container class="proj-info">
        <div class="subhead" :class="{'md': $vuetify.breakpoint.smAndUp}">
            <h1>{{projectInfo.name}}</h1>
            <h3>
                {{projectInfo.subtitle}}
            </h3>
        </div>
        <v-row>
            <v-col class="col-12 col-sm-6">
                <h2>About</h2>
                <div
                    v-if="projectInfo.about"
                    class="section-body">
                    <p v-for="(line, i) in projectInfo.about.split('\n')" :key="i" v-html="line"/>
                </div>
            </v-col>
            
            <v-col class="col-12 col-sm-6 download-install">
                <button 
                    v-if="projectInfo.download"
                    class="action-button"
                    outlined 
                    tile >
                    <a a :href="projectInfo.download">Download</a>
                </button>
                <button 
                    v-else
                    class="action-button"
                    outlined 
                    tile 
                    @click="downloadFile('download')">
                    <a>Download</a>
                </button>
                <h3>Current version: {{ changelog[0].version || projectInfo.version}}</h3>

                <h4 v-if="changelog[0].date">Last updated: {{changelog[0].date}}</h4>
                <h4 v-else>Last updated: {{projectInfo.updated}}</h4>

                <h3 v-if="!noInstall"><a href="#install">Install ↓</a></h3>
                <button 
                    v-if="projectInfo.source"
                    class="action-button small"
                    outlined 
                    tile 
                    @click="downloadFile('source')">
                    <a>Download Source</a>
                </button>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        projectInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        changelog: {
            type: Array,
            default: () => {
                return [{ }]
            }
        },
        noInstall: {
            type: Boolean,
            default: false
        }
    },
    computed: {

    },
    data: () => ({
        firebase: {}
    }),
    methods: {
        downloadFile (type) {
            const filename = (type == 'download') ? `${this.projectInfo.name}_${this.changelog[0].version}.zip` : `${this.projectInfo.name}_source.zip`
            this.firebase.storage().ref().child(`${type}/${filename}`).getDownloadURL().then((url) => {
                console.log(url);
                fetch(url)
                .then(t => {
                    return t.blob().then((b)=>{
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        a.setAttribute("download", filename);
                        a.click();
                    });
                })
                .catch(err => {
                    console.log('err');
                })
            });
        },
    },
    mounted() {
        setTimeout(() => {
            this.firebase = this.$store.state.firebase
            // console.log('this.firebase', this.firebase);
        }, 250);
    }
}
</script>
<style scoped>
.proj-info {
    margin-bottom: 32px;
}
.download-install>* {
    margin-bottom: 24px;
}
.subhead {
    font-weight: 500;
    margin-bottom: 64px;
    border-bottom: 10px solid var(--text-color);
}
.subhead.md {
    border-bottom: 16px solid var(--text-color);
}
.subhead h2 {
    margin-top: 14px;
}

</style>